export * from './scheduled-emails-req.interface';
export * from './scheduled-emails-table.interface';
